// extracted by mini-css-extract-plugin
export default {"teamLogo":"TeamLogo_teamLogo__9meXH","teamInitials":"TeamLogo_teamInitials__6Wm7m"};